import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import s from './styles.module.scss';

const Logo = ({ t }) => (
  <Link data-test="logo" to="/" className={s.logo}>
    <img srcSet="/images/logo.svg" alt="" />
    <span className={s.text}>{t('virtues')}</span>
  </Link>
);

Logo.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Logo);
